import { useEffect, useState } from 'react';
import { technicianAPI } from '../../services/api.js';
import { readVehicleList, withVehicleReadTimeout } from '../../utils/vehicleRead.js';

const pending = { rows: [], status: 'loading', message: 'جارٍ تحميل قائمة الفنيين…' };

// Optional lookup: its failure must not block authorized vehicle/visit reads.
export const useTechnicianCatalog = (vehicleId) => {
    const [catalog, setCatalog] = useState({ ...pending, vehicleId });
    useEffect(() => {
        let active = true;
        setCatalog({ ...pending, vehicleId });
        const load = async () => {
            try {
                const response = await withVehicleReadTimeout(technicianAPI.getAll());
                const rows = readVehicleList(response, 'technicians');
                if (active) setCatalog({ vehicleId, rows, status: 'available', message: '' });
            } catch (error) {
                if (active) setCatalog({
                    vehicleId, rows: [], status: 'unavailable',
                    message: error?.response?.status === 403
                        ? 'قائمة الفنيين غير متاحة لصلاحيات هذا الحساب. لم يتغير الفني المسجل.'
                        : 'قائمة الفنيين غير متاحة حاليًا. لم يتغير الفني المسجل؛ أعد تحميل الصفحة للمحاولة.',
                });
            }
        };
        load();
        return () => { active = false; };
    }, [vehicleId]);
    return catalog.vehicleId === vehicleId ? catalog : pending;
};
